import { useTranslation } from "react-i18next";
import { NavLink, useLocation, useParams } from "react-router-dom";

import { Alert, AlertDescription, AlertTitle } from "~/components/ui/alert";
import { ShopifyErrorIcon } from "~/components/ui/icons/shopify-error";
import type { BrandMatch } from "~/routes/root";

export const OrderShopifyNotConfiguredAlert: React.FC = () => {
  const { search } = useLocation();
  const { t } = useTranslation();

  const { brandId = "" } = useParams<BrandMatch>();

  return (
    <Alert appearance="error">
      <ShopifyErrorIcon />
      <AlertTitle>
        {t("order.integrations.shopify.shopify_error_installation_title")}
      </AlertTitle>
      <AlertDescription>
        {t("order.integrations.shopify.shopify_error_installation_text")}
        <br />
        <NavLink
          to={`/${brandId}/settings/integrations${search}`}
          className="underline"
        >
          {t("sidebar.settings")}
        </NavLink>
      </AlertDescription>
    </Alert>
  );
};
